module.exports = __webpack_public_path__ + "static/media/cat5.e4d14583.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat5.jpeg
// module id = 37
// module chunks = 0